import { createContext, FC, PropsWithChildren, useContext, useMemo } from 'react';
import { useNotableEvents } from '../../hooks/use-notable-events';
import { EventDefinition } from '../../notable-events';
import { Undefinable } from '../../types';

interface Context {
  notableEvents: EventDefinition[];
}

const context = createContext<Undefinable<Context>>(undefined);

export const NotableEventsProvider: FC<PropsWithChildren> = ({ children }) => {
  const notableEvents = useNotableEvents();

  const value = useMemo(() => ({ notableEvents }), [notableEvents]);

  return (
    <context.Provider value={value}>
      {children}
    </context.Provider>
  );
};

export const useNotableEventsContext = (): Context => {
  const data = useContext(context);
  if (!data) throw new Error('Missing NotableEventsProvider in tree above useNotableEventsContext');
  return data;
};
